module.exports = __webpack_public_path__ + "media/images/team/SKyriakos-a83816937f1f61aba84674970adf2f5f.jpg";